import React from 'react';

const Teleconciergerie: React.FC = () => {
  return (
    <div>
      {/* Hero Section - photo */}
      <section className="relative py-24 md:py-28 text-white overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/teleconcierge2.png"
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-prudens-bleu-fonce/70" aria-hidden="true" />
        </div>
        <div className="container-custom relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Prudens Téléconciergerie
          </h1>
          <p className="text-xl max-w-3xl text-white/95">
            Un accompagnement à domicile via un téléconcierge
          </p>
        </div>
      </section>

      {/* Qu'est-ce que c'est ? */}
      <section className="py-16 bg-gray-100">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-12 items-center">
            <div>
              <h2 className="section-title mb-6">Prudens Téléconciergerie, qu'est-ce que c'est ?</h2>
              <p className="text-lg text-gray-600 leading-relaxed">
              Un accompagnement à domicile via un téléconcierge : une solution qui allie simplicité d’usage 
              et relation humaine. Pensée pour les séniors et leurs aidants, elle permet de rester chez soi 
              tout en ayant un interlocuteur dédié à portée de main par téléphone, visio ou application.
              </p>
            </div>
            <div className="rounded-xl overflow-hidden shadow-xl bg-prudens-beige-sable">
              <img
                src="/teleconcierge4.png"
                alt="Téléconciergerie Prudens - accompagnement à domicile"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* L'outil et l'humain — deux blocs pleine largeur, alternance texte / visuel */}
      <section className="py-16 md:py-20 bg-gray-100">
        <div className="container-custom space-y-0">
          {/* Bloc 1 : Un outil technique — texte à gauche, visuel appli à droite */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 lg:gap-0 items-stretch overflow-hidden rounded-2xl shadow-xl bg-white border border-gray-200 mb-8 md:mb-10">
            <div className="p-8 md:p-10 lg:p-12 flex flex-col justify-start order-2 lg:order-1 border-l-4 border-prudens-bleu-clair">
              <h2 className="text-2xl md:text-3xl font-bold text-prudens-bleu-fonce mb-6">Un outil technique simplifié</h2>
              <ul className="text-gray-600 space-y-3 mb-6">
                <li className="flex items-start gap-2">
                  <span className="text-prudens-bleu-clair mt-1.5 shrink-0">•</span>
                  <span>Un point d'accès unique à son téléconcierge dédié.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-prudens-bleu-clair mt-1.5 shrink-0">•</span>
                  <span>Une interface claire, rassurante et adaptée.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-prudens-bleu-clair mt-1.5 shrink-0">•</span>
                  <span>Un meilleur accompagnement pour les séniors.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-prudens-bleu-clair mt-1.5 shrink-0">•</span>
                  <span>Un outil qui soulage la charge des aidants.</span>
                </li>
              </ul>
              <p className="text-sm text-gray-500">
                Appel visio, appel téléphonique, appel d'urgence : tout depuis une même application.
              </p>
            </div>
            <div className="relative min-h-[280px] lg:min-h-0 bg-gray-50 flex items-center justify-center p-8 order-1 lg:order-2">
              <div className="w-full max-w-[280px] mx-auto">
                <img
                  src="/Charles.png"
                  alt="Interface de l'application Prudens — Appel vidéo, audio et urgence"
                  className="w-full h-auto object-contain drop-shadow-lg"
                />
              </div>
            </div>
          </div>

          {/* Bloc 2 : Une présence humaine — visuel visio à gauche, texte à droite */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 lg:gap-0 items-stretch overflow-hidden rounded-2xl shadow-xl bg-white border border-gray-200">
            <div className="relative min-h-[280px] lg:min-h-0 bg-gray-100 flex items-center justify-center p-0 order-1">
              <img
                src="/teleconcierge2.png"
                alt="Un senior en visio avec son téléconcierge Prudens"
                className="w-full h-full min-h-[280px] object-cover object-center"
              />
            </div>
            <div className="p-8 md:p-10 lg:p-12 flex flex-col justify-start order-2 border-l-4 border-prudens-rouge-doux">
              <h2 className="text-2xl md:text-3xl font-bold text-prudens-bleu-fonce mb-6">Une présence humaine à l'écoute</h2>
              <ul className="text-gray-600 space-y-3">
                <li className="flex items-start gap-2">
                  <span className="text-prudens-rouge-doux mt-1.5 shrink-0">•</span>
                  <span>Un visage familier et bienveillant, disponible pour faciliter la vie courante et l'accès à tous les services de proximité.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-prudens-rouge-doux mt-1.5 shrink-0">•</span>
                  <span>Une écoute active : au-delà des services rendus, une véritable écoute pour rompre l'isolement.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-prudens-rouge-doux mt-1.5 shrink-0">•</span>
                  <span>Une gestion centralisée des demandes, tant pour le sénior que pour son aidant.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Nos services */}
      <section className="py-16 bg-gray-100">
        <div className="container-custom">
          <h2 className="section-title text-center mb-12">Nos services</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="bg-prudens-bleu-clair h-16 w-16 rounded-full flex items-center justify-center mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-prudens-bleu-fonce mb-4">Assistance administrative et solidaire</h3>
              <p className="text-gray-600 mb-4">
                Aide pour la prise de rendez-vous, l'organisation de déplacements, l'information des services publics. Veille solidaire pour lutter contre l'isolement.
              </p>
              <ul className="text-gray-600 space-y-2">
                <li className="flex items-start gap-2">
                  <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center mt-0.5">
                    <svg className="h-5 w-5 min-w-[1.25rem] min-h-[1.25rem] text-prudens-rouge-doux" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </span>
                  Prise de rendez-vous de confort
                </li>
                <li className="flex items-start gap-2">
                  <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center mt-0.5">
                    <svg className="h-5 w-5 min-w-[1.25rem] min-h-[1.25rem] text-prudens-rouge-doux" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </span>
                  Information sur les activités culturelles et associatives locales 
                </li>
                <li className="flex items-start gap-2">
                  <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center mt-0.5">
                    <svg className="h-5 w-5 min-w-[1.25rem] min-h-[1.25rem] text-prudens-rouge-doux" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </span>
                  Appels de convivialité
                </li>
              </ul>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="bg-prudens-bleu-clair h-16 w-16 rounded-full flex items-center justify-center mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-prudens-bleu-fonce mb-4">Services du quotidien</h3>
              <p className="text-gray-600 mb-4">
                Coordination de livraisons, courses, services à domicile, et autres besoins du quotidien.
              </p>
              <ul className="text-gray-600 space-y-2">
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  Commande de repas
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  Coordination des intervenants
                </li>
              </ul>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="bg-prudens-bleu-clair h-16 w-16 rounded-full flex items-center justify-center mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-prudens-bleu-fonce mb-4">Plateforme pour les aidants</h3>
              <p className="text-gray-600 mb-4">
                La téléconciergerie soulage l'aidant pour accompagner son sénior.
              </p>
              <ul className="text-gray-600 space-y-2">
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  Accède à l'application Prudens et ses téléconcierges
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  Bénéficie des partenaires de Prudens
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Comment ça marche - Parcours utilisateur */}
      <section className="py-16 bg-gray-100">
        <div className="container-custom">
          <h2 className="section-title text-center mb-4">Comment ça marche ?</h2>
          <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
            Suivez le parcours de Marie pour comprendre comment la Téléconciergerie Prudens s'adapte à son quotidien.
          </p>

          {/* Persona */}
          <div className="flex justify-center mb-12">
            <div className="inline-flex items-center gap-4 bg-white rounded-2xl shadow-lg px-6 py-4 border-l-4 border-prudens-rouge-doux">
              <div className="w-14 h-14 rounded-full bg-prudens-beige-sable flex items-center justify-center">
                <svg className="w-8 h-8 text-prudens-bleu-fonce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <div>
                <p className="font-bold text-prudens-bleu-fonce text-lg">Marie, 78 ans</p>
                <p className="text-sm text-gray-500">Vit seule, souhaite rester chez elle en toute sérénité</p>
              </div>
            </div>
          </div>

          {/* Parcours visuel */}
          <div className="max-w-4xl mx-auto space-y-6">
            {/* Étape 1 */}
            <div className="flex flex-col md:flex-row md:items-center gap-4">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-prudens-bleu-fonce text-white flex items-center justify-center font-bold">1</div>
              <div className="flex-1 bg-white rounded-xl p-6 shadow-md border border-gray-100">
                <h3 className="font-bold text-prudens-bleu-fonce mb-2">Marie a un besoin</h3>
                <p className="text-gray-600 text-sm">
                  Aide à la vie courante (courses, rendez-vous, démarches) ou accès aux services d'urgence. Depuis l'application, Marie appelle son téléconcierge ou lui envoit un message.
                </p>
              </div>
            </div>

            <div className="flex justify-center">
              <svg className="w-8 h-8 text-prudens-bleu-grise" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </div>

            {/* Étape 2 - Téléconciergerie */}
            <div className="flex flex-col md:flex-row md:items-center gap-4">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-prudens-bleu-clair text-white flex items-center justify-center font-bold">2</div>
              <div className="flex-1 bg-prudens-bleu-fonce text-white rounded-xl p-6 shadow-lg">
                <h3 className="font-bold mb-2">Le Téléconcierge de Prudens répond</h3>
                <p className="text-gray-200 text-sm mb-3">
                  Le concierge dédié prend en charge la demande. Disponible du lundi au vendredi, de 8h à 18h et le samedi de 9h à 12h.
                </p>
                <p className="text-xs text-prudens-beige-sable">Un visage familier, une écoute bienveillante.</p>
              </div>
            </div>

            <div className="flex justify-center">
              <svg className="w-8 h-8 text-prudens-bleu-grise" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </div>

            {/* Deux chemins */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Chemin A : Services */}
              <div className="bg-white rounded-xl p-6 shadow-md border-t-4 border-prudens-bleu-clair">
                <div className="flex items-center gap-2 mb-3">
                  <span className="w-8 h-8 rounded-full bg-prudens-bleu-clair/20 text-prudens-bleu-fonce flex items-center justify-center text-sm font-bold">A</span>
                  <h3 className="font-bold text-prudens-bleu-fonce">Besoin de services</h3>
                </div>
                <p className="text-gray-600 text-sm mb-4">
                  Le téléconcierge sélectionne, recherche et passe commande auprès des <strong>partenaires du territoire</strong>.
                </p>
                <p className="text-prudens-bleu-clair text-sm font-medium">→ Le service est livré à Marie</p>
              </div>

              {/* Chemin B : Lien social */}
              <div className="bg-white rounded-xl p-6 shadow-md border-t-4 border-prudens-rouge-doux">
                <div className="flex items-center gap-2 mb-3">
                  <span className="w-8 h-8 rounded-full bg-prudens-rouge-doux/20 text-prudens-bleu-fonce flex items-center justify-center text-sm font-bold">B</span>
                  <h3 className="font-bold text-prudens-bleu-fonce">Lien social, écoute</h3>
                </div>
                <p className="text-gray-600 text-sm mb-4">
                  Pour rompre l'isolement, le téléconcierge travaille en <strong>collaboration</strong> avec des acteurs de lien social (écoute, convivialité).
                </p>
                <p className="text-prudens-rouge-doux text-sm font-medium">→ Marie reste connectée</p>
              </div>
            </div>

            {/* Aidants */}
            <div className="flex flex-col md:flex-row md:items-center gap-4 pt-4">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-prudens-bleu-grise text-white flex items-center justify-center">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <div className="flex-1 bg-white rounded-xl p-5 shadow-md border border-gray-100">
                <h3 className="font-bold text-prudens-bleu-fonce mb-2">Les aidants restent informés</h3>
                <p className="text-gray-600 text-sm">
                  La téléconciergerie partage les <strong>informations</strong> et <strong>disponibilités</strong> avec les proches aidants de Marie, pour une coordination en toute sérénité.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

       {/* Tarifs 
      <section className="py-16 bg-white">
        <div className="container-custom">
          <h2 className="section-title text-center mb-12">Nos formules</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
              <div className="bg-prudens-bleu-clair py-6 text-center text-white">
                <h3 className="text-2xl font-bold">Essentiel</h3>
                <p className="text-xl mt-2">29€/mois</p>
              </div>
              <div className="p-6">
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    1 appel hebdomadaire
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    Assistance administrative basique
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    Hotline d'urgence 24/7
                  </li>
                </ul>
                <button className="btn btn-primary w-full">
                  Choisir
                </button>
              </div>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg overflow-hidden border-2 border-prudens-rouge-doux transform scale-105">
              <div className="bg-prudens-rouge-doux py-6 text-center text-white">
                <span className="inline-block px-3 py-1 bg-white text-prudens-rouge-doux text-sm font-bold rounded-full mb-2">Recommandé</span>
                <h3 className="text-2xl font-bold">Confort</h3>
                <p className="text-xl mt-2">59€/mois</p>
              </div>
              <div className="p-6">
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    3 appels hebdomadaires
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    Assistance administrative complète
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    Coordination des services
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    Hotline d'urgence 24/7
                  </li>
                </ul>
                <button className="btn btn-primary w-full">
                  Choisir
                </button>
              </div>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
              <div className="bg-prudens-bleu-fonce py-6 text-center text-white">
                <h3 className="text-2xl font-bold">Premium</h3>
                <p className="text-xl mt-2">89€/mois</p>
              </div>
              <div className="p-6">
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    Appels quotidiens
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    Services administratifs illimités
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    Concierge personnel dédié
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-prudens-rouge-doux mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    Rapport mensuel pour les proches
                  </li>
                </ul>
                <button className="btn btn-primary w-full">
                  Choisir
                </button>
              </div>
            </div>
          </div>
          
          <p className="text-center text-gray-600 mt-8">
            Des aides financières sont possibles. Contactez-nous pour en savoir plus.
          </p>
        </div>
      </section> */}
    </div>
  );
};

export default Teleconciergerie;